export default __webpack_public_path__ + "static/media/Arch_Amazon-EKS_512.d508447e.png";